export class LoginModel {
    login: string;
    password: string;
    
}

export class ResetPasswordData {
    userName: string;
    password: string;
    token: string;
}

export class ResetFormRequest {
    url: string;
    username: string;
}

export class WebToken {
    accessToken: string;
    refreshToken: string;
}

export class UserForMention {
    name: string;
    email: string;
}